import ClubLifePostActionSheet from "../common/ClubLifePostActionSheet";
import ClubLifeEditPostSheet from "../common/ClubLifeEditPostSheet";

export default function ClientPostManageModals({
  menuPost,
  menuAnchor,
  editPost,
  busy,
  closeMenu,
  openEdit,
  closeEdit,
  confirmDelete,
  confirmEdit,
  allowCategory = false,
}) {
  return (
    <>
      <ClubLifePostActionSheet
        post={menuPost}
        open={Boolean(menuPost)}
        busy={busy}
        anchor={menuAnchor}
        onClose={closeMenu}
        onEdit={openEdit}
        onDelete={confirmDelete}
      />
      <ClubLifeEditPostSheet
        post={editPost}
        open={Boolean(editPost)}
        busy={busy}
        onClose={closeEdit}
        onSave={confirmEdit}
        allowCategory={allowCategory}
      />
    </>
  );
}
